module.exports = __webpack_public_path__ + "img/no_data_lab_type.2a90346d.png";